export class CompanyBaskets {
    baskets = [];
    constructor(baskets) {
        this.baskets = baskets;
    }
    get() {
        return this.baskets;
    }
}
